import { isNullOrUndefined } from './checker.utils';

/**
 * Appends a numeric value to FormData as string.
 * @param formData FormData instance that should receive the value.
 * @param key Backend field key.
 * @param value Numeric value to append.
 * @returns Nothing.
 */
export function appendNumber(
  formData: FormData,
  key: string,
  value: number
): void {
  formData.append(key, value.toString());
}

/**
 * Appends an optional numeric value to FormData as string.
 * @param formData FormData instance that should receive the value.
 * @param key Backend field key.
 * @param value Optional numeric value to append.
 * @returns Nothing.
 */
export function appendOptionalNumber(
  formData: FormData,
  key: string,
  value: number | null
): void {
  formData.append(key, isNullOrUndefined(value) ? '' : value.toString());
}

/**
 * Appends an optional image to FormData for update operations.
 * @param formData FormData instance that receives the image field.
 * @param imageFile Optional image file to upload.
 * @returns Nothing.
 */
export function appendOptionalImage(
  formData: FormData,
  imageFile: File | null
): void {
  if (isNullOrUndefined(imageFile)) {
    formData.append('img', '');
    return;
  }

  formData.append('img', imageFile);
}
